var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiveTrendingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80952 0H16.1905C18.2944 0 20 1.70558 20 3.80952V16.1905C20 18.2944 18.2944 20 16.1905 20H3.80952C1.70558 20 0 18.2944 0 16.1905V3.80952C0 1.70558 1.70558 0 3.80952 0ZM16.1905 18.5714C17.5054 18.5714 18.5714 17.5054 18.5714 16.1905V3.80952C18.5714 2.49456 17.5054 1.42857 16.1905 1.42857H3.80952C2.49456 1.42857 1.42857 2.49456 1.42857 3.80952V16.1905C1.42857 17.5054 2.49456 18.5714 3.80952 18.5714H16.1905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2381 6.90476H12.381C11.9865 6.90476 11.6667 7.22456 11.6667 7.61905C11.6667 8.01354 11.9865 8.33333 12.381 8.33333H13.2667L9.87619 11.7238L7.97143 9.81905C7.46597 9.31534 6.64831 9.31534 6.14286 9.81905L3.65714 12.2286C3.37862 12.5074 3.37862 12.9592 3.65714 13.2381C3.79037 13.373 3.97232 13.4485 4.16191 13.4476C4.35171 13.4496 4.53407 13.3739 4.66667 13.2381L7.01905 10.8857L8.92381 12.7905C9.43253 13.2953 10.2532 13.2953 10.7619 12.7905L14.4857 9.06667V10.4762C14.4857 10.8707 14.8055 11.1905 15.2 11.1905C15.5945 11.1905 15.9143 10.8707 15.9143 10.4762V7.61905C15.9101 7.24085 15.6155 6.92962 15.2381 6.90476Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiveTrendingUp);
export default __webpack_public_path__ + "static/media/hive-trending-up.53da99550fc465a6d66d5d311e83f626.svg";
export { ForwardRef as ReactComponent };